module.exports = __webpack_public_path__ + "static/teaser-6940351eb29f6e493540c245e3fb7fbc.gif";